import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { OrganizationDetailContent } from './OrganizationDetailContent';

export default function OrganizationDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <OrganizationDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
